import IMask from 'imask';

const FIELD_IS_REQUIRED = 'Обязательное поле';
const PHONE_IS_NOT_VALID = 'Телефон не валиден';
const EMAIL_IS_NOT_VALID = 'Почта не валидна';
const JS_LABEL_SELECTOR = '.js-label';
const JS_LABEL_ERROR_SELECTOR = JS_LABEL_SELECTOR + '-error'
const LABEL_ERROR_ACTIVE_CLASS = 'error-message'


function initForms(doc) {
    if (!doc) doc = document
    initMasks();
    const forms = doc.querySelectorAll('.js-form');

    if (forms.length) {
        forms.forEach(function (form) {
            listenForm(form)
        })
    }
}
$(window).on('load', function() {
    initForms(document)
});

function listenForm(form) {
    let $form = $(form)
    $form.on('submit', function (event) {
        event.preventDefault();
        if (validateForm($form)) {
            let data = $form.serializeArray();
            let errorNode = $form.find('.js-error');
            let successNode = $form.find('.js-success');

            $.ajax({
                url: $form.attr('action'),
                type: $form.attr('method'),
                data,
                success(response) {
                    let parsedResponse = JSON.parse(response)
                    if (parsedResponse.status) {
                        cleanForm($form)
                        errorNode.html();
                        errorNode.removeClass('active');
                        successNode.addClass('active');
                        successNode.html(parsedResponse.message)
                        callYm($form)
                        // closeModals()
                        // yaCounter22097518.reachGoal('FormaDone');
                        // ga('create', 'UA-115745302-1');
                        // ga('send', {
                        //     hitType: 'event',
                        //     eventCategory: 'Forma',
                        //     eventAction: 'FormaDone',
                        //     eventLabel: window.location.href
                        // })
                        // callSuccessModal()
                    } else {
                        console.log(errorNode)
                        errorNode.html(parsedResponse.message);
                        errorNode.addClass('active');
                        successNode.removeClass('active');
                        successNode.html()
                    }
                },
                error(response) {
                    // closeModals()
                }
            })
        }

        return false;
    })
}

// Вернуть инпуты у формы
function getFields($form) {
    return $form.find('input', 'textarea')
}

function callYm($form) {
    console.log($form.data('ym-action'))
    if ($form && $form.data('ym-id') && $form.data('ym-action')) {
        ym($form.data('ym-id'),'reachGoal',$form.data('ym-action'))

    }
}

//Провалидировать поля
function validateForm(form) {
    let fields = getFields(form)
    let validated = true

    if (fields.length) {
        fields.each(function(index, field) {
            let $field = $(field)
            if (!$field.data('no-validation')) {
                let fieldValidError = validateField($field)
                processFieldError($field, fieldValidError)
                if (fieldValidError) {
                    validated = false;
                    //выходим из цикла, чтобы не проверять дальше
                    return false;
                }
            }
        })
    }
    return validated
}

function validateField(field) {
    if (field.data('required') && !field.val()) return FIELD_IS_REQUIRED

    if (
        field.data('validate') == 'phone'
        && checkPhone(field.val())
    ) return PHONE_IS_NOT_VALID

    if (
        field.data('validate') == 'email'
        && checkEmail(field.val())
    ) return EMAIL_IS_NOT_VALID
}

function cleanForm($form) {
    let $fields = $form.find('input', 'textarea')

    if ($fields.length) {
        $fields.each(function (index, field) {
            let $field = $(field)

            $field.val('');
            processFieldError($field, '')
        })
    }
}

function processFieldError(field, error = '') {
    if (!field) return false;
    field.attr('placeholder', error);
    if (error) {
        field.addClass(LABEL_ERROR_ACTIVE_CLASS)
    } else {
        field.removeClass(LABEL_ERROR_ACTIVE_CLASS)
    }
}

function initMasks() {
    let inputs = document.querySelectorAll('input[data-mask="phone"]');

    if (inputs.length) {
        inputs.forEach(function (input) {
            IMask(
                input, {
                    mask: '+{7} (000) 000-00-00'
                });
        })
    }
}

//validators
function checkEmail(string) {
    return !!string.search(/^[-._a-z0-9]+@+[a-z0-9-]+\.[a-z]{2,6}$/i)
}

function checkPhone(string) {
    return !!string.search(/^\+7\s\(([0-9]{3})\)\s([0-9]{3})-([0-9]{2})-([0-9]{2})$/i)
}
export { listenForm };